import React from 'react';
import './results.css';
import ResultCard from './ResultCard';

function Results({ poiList=[]}) {

  return (
      poiList.length === 1 && poiList[0].name === 'loading'
      ? <div className="d-flex justify-content-center align-self-center w-100">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      : <div className="poi w-100">
            {Object.keys(poiList).length === 0
            ? 
            <div className="no-poi">
              <h4>
                Maaf, POI tidak dapat ditemukan ...
              </h4>
            </div>
            
            :
            <div className="d-flex justify-content-left align-self-start flex-wrap mt-4 margin-auto" id="cont">
            {poiList.map((poi) => <ResultCard key={poi.id} {...poi}/> )}
            </div>
            }
      </div>
  );
}

export default Results;
